import { FULFILMENT_PICK_UP_METHODS } from './constants';

const canRequestShippingLabels = shipment =>
  shipment?.addressing?.to?.entity_type === 'address' &&
  !!shipment?.method_id &&
  !FULFILMENT_PICK_UP_METHODS.includes(shipment?.method_id);

export default canRequestShippingLabels;
